module.exports = __webpack_public_path__ + "media/images/lb/098-f34b141769a932332628a831dae2ce55.svg";